import axios from 'axios'
import Cookies from 'js-cookie'
import store, { actionCreators } from '../store'
import { ACCOUNT_NAME_KEY } from '../constants'

// axios.defaults.baseURL = 'http://localhost:7001/api'
axios.defaults.baseURL = '/api'
axios.defaults.withCredentials = true

axios.interceptors.request.use(config => {
  config.headers = Object.assign(config.headers, {
    'X-Requested-With': 'XMLHttpRequest',
  })
  return config
})

axios.interceptors.response.use(response => {
  const data = response.data
  if (data.code && Number(data.code) === 401) {
    Cookies.remove(ACCOUNT_NAME_KEY, { path: '' })
    store.dispatch(actionCreators.setLoginStatus(false))
    setTimeout(() => {
      window.location.href = '/#login'
    })
  }
  return data
})

export const get = (url, params, options) => {
  return axios.get(url, { params, ...options })
}

export const post = (url, data, options) => {
  return axios.post(url, data, options)
}
